const imdbApikey = '';

export default imdbApikey;

